import React, { ReactElement, memo } from 'react';

import styles from './Spinner.css';
import { ReactComponent as SpinnerIcon } from 'img/icons/spinner.svg';

export const Spinner = memo(
    (): ReactElement => {
        return <SpinnerIcon className={styles.root} width={40} height={40} />;
    }
);

Spinner.displayName = 'Spinner';
